import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWH5M8F1 (請款單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fh110_01: string;  // 請款單號
  fh110_11: string;  // 請款日期
  fh110_12: string;  // 原幣請款金額
  fh110_13: string;  // 原幣請款總額含稅
  fh110_16: string;  // 申請人/公司代碼
  fh110_22: string;  // 請款類別
  fh110_221: string; // 請款類別名稱（計算欄）
  fh110_37: string;  // 部門代碼
  fh110_80: string;  // 核准旗標/層級
  fh110_801: string; // 目標核准層級（計算欄）
  fh110_802: string; // 核准層級顯示名稱（計算欄）
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwh5m8Api = {
  /** Query payment request candidates eligible for approval reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwh5m8/candidates', { params });
    return res.data;
  },

  /** Execute batch approval reversal for selected payment requests.
   * confirmed:true reflects the confirm dialog the caller already showed
   * (PWH5M8-VAL-REVERSE-CONFIRM-DIALOG) — the backend model declares this
   * field but does not yet enforce it (see backend/modules/pwh5m8f1/models/
   * pwh5m8f1.go's ReverseRequest doc comment), so sending it now is a no-op
   * today and forward-compatible with the deferred enforcement pass. */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwh5m8/reverse', { items, confirmed: true });
    return res.data;
  },
};
